import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const notesApi = createApi({
  reducerPath: 'notesApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['notes'],
  endpoints: (builder) => ({
    saveNotesDetails: builder.mutation({
      query(body) {
        return {
          url: spotFinder.NotesController.saveNotesDetails,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    findByUserId: builder.mutation({
      query(body) {
        return {
          url: spotFinder.NotesController.findByUserId,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const { useSaveNotesDetailsMutation, useFindByUserIdMutation } = notesApi;
